import * as actionTypes from '../actions/actionsTypes';

const initialState = {
        sharingRaceData: {
            data: {
            }
        }
    };


export const sharingRaceDataReducer = (state = initialState, action) => {
    switch (action.type ){
        case actionTypes.FETCH_SHARING_SESSIONS:
            return {
                ...state,
                sharingRaceData: action.payload,
            };
        case actionTypes.UPDATE_SHARING_SESSIONS_FROM:
            return {
                ...state,
                sharingRaceData: action.payload,
            };
        case actionTypes.EMPTY_SHARING_SESSIONS_FROM:
            return {
                ...state,
                sharingRaceData: action.payload,
            };
        default:
            return state;
    }

};